<template>
	<div class="debitCard">
		<h3 class="smallTitle">{{'components/settings/new-card.title' | trans}}</h3>
		<form @submit.prevent="submit">
			<Input
				:label="'components/settings/new-card.name-on-card' | trans"
				id="name"
				v-model="card.nameOnCard"
				:v="$v.card.nameOnCard"
				:requiredMessage="'components/settings/new-card.name-is-required' | trans"
			/>
			<Input
				:label="'components/settings/new-card.card-number' | trans"
				id="card_number"
				:v="$v.card.pan"
				v-model="card.pan"
				maxlength="22"
				:minLengthMessage="'components/settings/new-card.card-minimum-numbers' | trans({number:16})"
				:maxLengthMessage="'components/settings/new-card.card-numbers-from-to' | trans({from:16,to:18})"
				:numbersAndSpacesMessage="'components/settings/new-card.should-only-contain-numbers' | trans"
			/>
			<div class="inputThreeCols">
				<div class="selectWrap" :class="{'hasError' : selectsValidation.expiryMonthError}">
					<label>{{'components/settings/new-card.expiry-date' | trans}}</label>
					<v-select
						:options="months"
						v-model="card.month"
						:reduce="month => month.value"
						label="label"
					/>
					<div class="error" v-if="selectsValidation.expiryMonthError">
						{{'components/settings/new-card.date-is-required' | trans}}
					</div>
				</div>
				<div class="selectWrap" :class="{'hasError' : selectsValidation.expiryYearError}">
					<label class="transparent">{{'components/settings/new-card.expiry-year' | trans}}</label>
					<v-select
						:options="years"
						v-model.number="card.year"
						:reduce="year => year.value"
						label="label"
					/>
					<div class="error" v-if="selectsValidation.expiryYearError">
						{{'components/settings/new-card.date-is-required' | trans}}
					</div>
				</div>
				<Input
					label="CVV"
					id="cvv"
					:v="$v.card.cvv"
					v-model="card.cvv"
					maxlength="4"
					:requiredMessage="'components/settings/new-card.cvv-is-required' | trans"
				/>
			</div>
			<slot></slot>
			<br>
			<PulseLoader v-if="loader" size="8px" color="#00B2FF"/>
			<div v-else>
				<button class="btn process">{{buttonLabel}}</button>
			</div>


		</form>
	</div>
</template>

<script>
    import Input from '../form/Input';
    import vSelect from '../temp/MyVueSelect';
    import {required, minLength, maxLength, numeric} from 'vuelidate/lib/validators';
    import {creditCardFormatInput, numbersAndSpaces} from '../../helpers/form';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    const length16or18 = (value) => {
        if (!value) {
            return false;
        }
        return value.length == 19 || value.length == 22;
    };

    export default {
        props: ['expiryDateYear', 'expiryDateMonth', 'cvv', 'pan', 'nameOnCard', 'submitButtonLabel', 'loading'],
        data() {
            return {
                name: '',
                cardNumber: null,
                monthsData: [
                    lang.get('components/settings/new-card.months.January'),
                    lang.get('components/settings/new-card.months.February'),
                    lang.get('components/settings/new-card.months.March'),
                    lang.get('components/settings/new-card.months.April'),
                    lang.get('components/settings/new-card.months.May'),
                    lang.get('components/settings/new-card.months.June'),
                    lang.get('components/settings/new-card.months.July'),
                    lang.get('components/settings/new-card.months.August'),
                    lang.get('components/settings/new-card.months.September'),
                    lang.get('components/settings/new-card.months.October'),
                    lang.get('components/settings/new-card.months.November'),
                    lang.get('components/settings/new-card.months.December'),
                ],
                years: [],
                months: [],
                selectsValidation: {
                    expiryMonthError: false,
                    expiryDayError: false,
                    expiryYearError: false,
                    billingAddressError: false
                },
                card: {
                    cvv: null,
                    pan: null,
                    year: null,
                    month: null,
                    nameOnCard: null,
                },
                buttonLabel: lang.get('components/settings/new-card.buttons.submit'),
                formLoading: false,
                disableValidation: false
            }
        },
        model: {
            event: 'clear',
        },
        validations: {
            card: {
                nameOnCard: {
                    required
                },
                pan: {
                    required,
                    numbersAndSpaces,
                    length16or18,
                },
                cvv: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(4),
                    numeric
                },
                month: {
                    required
                },
                year: {
                    required
                }
            },
        },
        components: {Input, vSelect, PulseLoader},
        methods: {
            submit: function () {
                this.validateExpiryYear();
                this.validateExpiryMonth();

                this.$v.$touch();

                if (this.$v.$pending || this.$v.$error || !this.card.month || !this.card.year) {
                    return;
                }
                // to form submit after this
                this.$emit('submitCard', this.card);
            },
            getExpiryYears() {
                let dates = [];
                for (let i = 0; i <= 5; i++) {
                    let year = new Date(new Date().getFullYear() + i, 1, 1).getFullYear();
                    dates.push({
                        label: year,
                        value: year,
                    });
                }
                return dates;
            },
            getExpiryMonths() {
                let data = [];
                this.monthsData.forEach(function (monthString, index) {
                    data.push({value: (index + 1), label: monthString});
                });
                return data;
            },
            validateExpiryMonth: function () {
                this.card.month ? this.selectsValidation.expiryMonthError = false : this.selectsValidation.expiryMonthError = true;

                if (this.card.year <= new Date().getFullYear() && this.card.month && this.card.month < (new Date().getMonth() + 1)) {
                    this.selectsValidation.expiryMonthError = true;
                }
            },
            validateExpiryYear: function () {
                this.card.year ? this.selectsValidation.expiryYearError = false : this.selectsValidation.expiryYearError = true;

                let dateObject = new Date();

                if (this.card.year > dateObject.getFullYear() || (this.card.year <= dateObject.getFullYear() && this.card.month && this.card.month >= (dateObject.getMonth() + 1))) {
                    this.selectsValidation.expiryMonthError = false;
                } else {
                    this.selectsValidation.expiryMonthError = true;
                }
            },
            resetForm: function () {
                new Promise((resolve, reject) => {
                    this.card = {
                        cvv: null,
                        pan: null,
                        year: null,
                        month: null,
                        nameOnCard: null,
                    };
                    this.selectsValidation = {
                        expiryMonthError: false,
                        expiryDayError: false,
                        expiryYearError: false,
                        billingAddressError: false
                    };
                    this.selectsValidation.expiryMonthError = false;
                    this.$v.$reset();
                    resolve();
                }).then((r) => {
                    this.selectsValidation.expiryYearError = false;
                    this.selectsValidation.expiryMonthError = false;
                }).catch(err => console.log(err));
            }
        },
        computed: {
            loader: function () {
                return this.loading ? true : false;
            }
        },
        watch: {
            'card.pan': function () {
                this.card.pan = creditCardFormatInput(this.card.pan);
            },
            'card.month': function () {
                this.validateExpiryMonth();
            },
            'card.year': function () {
                this.validateExpiryYear();
            }
        },
        created: function () {
            this.years = this.getExpiryYears();
            this.months = this.getExpiryMonths();

            if (this.expiryDateYear) {
                this.card.year = this.expiryDateYear;
            }

            if (this.expiryDateMonth) {
                this.card.month = this.expiryDateMonth;
            }

            if (this.pan) {
                this.card.pan = this.pan;
            }

            if (this.nameOnCard) {
                this.card.nameOnCard = this.nameOnCard;
            }

            if (this.cvv) {
                this.card.cvv = this.cvv;
            }

            this.buttonLabel = this.submitButtonLabel ? this.submitButtonLabel : this.buttonLabel;

        }
    }
</script>
